define('commons/arc-progress',['jquery', 'd3js'], function($, d3) {

    var ArcProgress = function(container, name, options) {
        this.options = {
            'width': 300,
            'legendWidth': 150,
            'height': 300,
            'radius': 130,
            'inner': 80,
            'margin': 30,
            'legendBulletOffset': 40,
            'legendBulletSize': 5,
            'legendTextOffset': 15,
            'textVerticalSpace': 20,
            'completeColor': '#2ecc71',
            'progressColor': '#f1c40f',
            'notStartedColor': '#ddd',
            'failedColor': '#e74c3c',
            'pendingRestartColor': '#00BFFF'
        };
        // Extends options
        $.extend(this.options, options);
        this.name = name;
        this.container = container;
        this.colors = d3.scale.ordinal().range(
                [this.options.completeColor, this.options.failedColor, this.options.progressColor, this.options.pendingRestartColor, this.options.notStartedColor]);
        $(this.container).css('width', this.options.width + this.options.legendWidth);
        $(this.container).css('height', this.options.height);
        this.draw();
    };

    ArcProgress.prototype.setTotal = function(total) {
        this.total = total;
    };

    ArcProgress.prototype.draw = function() {
        if (this.svg === undefined) {
            var self = this;
            this.arc = d3.svg.arc().innerRadius(this.options.inner).outerRadius(this.options.radius);

            this.pie = d3.layout.pie().sort(null).value(function(d) {
                return d.value;
            });

            this.vis = d3.select(this.container).append('svg:svg').attr('width', this.options.width + this.options.legendWidth).attr('height',
                    this.options.height).attr('class', 'svg-' + this.name).append('svg:g').attr('transform',
                    'translate(' + this.options.width / 2 + ',' + this.options.height / 2 + ')');
            var data = [{
                'label': 'Finished',
                'value': 0
            }, {
                'label': 'Failed',
                'value': 0
            }, {
                'label': 'Started',
                'value': 0
            }, {
                'label': 'Pending restart',
                'value': 0
            },{
                'label': 'Total',
                'value': 1
            }];
            this.path = this.vis.selectAll('path').data(this.pie(data)).enter().append('path').attr('fill', function(d, i) {
                return self.colors(i);
            }).attr('d', this.arc).each(function(d) {
                this._current = d;
            });

            this.textTop = this.vis.append('text').attr('dy', '.35em').style('text-anchor', 'middle').attr('class', 'textTop').attr('y', -10).attr(
                    'transform', 'translate(0, 0)');

            this.textBottom = this.vis.append('text').attr('dy', '.35em').style('text-anchor', 'middle').attr('class', 'textBottom').attr('y', 10)
                    .attr('transform', 'translate(0, 0)');

            var legend = this.vis.append('g').attr('class', 'legend').attr('width', this.options.width + this.options.legendWidth).attr('height',
                    this.options.height).selectAll('g').data(data).enter().append('g').attr('transform', function(d, i) {
                return 'translate(0, 0)';
            });
            legend.append('text').attr('x', this.options.radius + this.options.legendBulletOffset + this.options.legendTextOffset).attr('y',
                    function(d, i) {
                        return i * self.options.textVerticalSpace - self.options.margin;
                    }).attr('dy', '.35em').text(function(d) {
                return d.label;
            }).style('fill', function(d, i) {
                return self.colors(i);
            });

            legend.append('svg:circle').attr('cx', this.options.radius + this.options.legendBulletOffset).attr('cy', function(d, i) {
                return i * self.options.textVerticalSpace - self.options.margin;
            }).attr('stroke-width', '.5').style('fill', function(d, i) {
                return self.colors(i);
            }).attr('r', this.options.legendBulletSize);
        }
    };

    ArcProgress.prototype.arcTween = function(context) {
        return function(a) {
            var i = d3.interpolate(this._current, a);
            this._current = i(0);
            return function(t) {
                return context.arc(i(t));
            };
        };
    };

    ArcProgress.prototype.update = function(complete, progress, notStarted, failed, pendingRestart) {
        var self = this;
        var percent = complete * 100 / this.total;
        var values = [{
            'label': 'Finished',
            'value': complete
        }, {
            'label': 'Failed',
            'value': failed
        }, {
            'label': 'Started',
            'value': progress
        }, {
            'label': 'Pending restart',
            'value': pendingRestart
        }, {
            'label': 'Total',
            'value': (this.total - complete - failed - progress - pendingRestart)
        }];
        this.path = this.path.data(this.pie(values));
        this.path.transition().duration(750).attrTween('d', this.arcTween(this));
        this.textBottom.text(complete + ' / ' + this.total);
        this.textTop.text(percent.toFixed(2) + ' %');
    };

    return ArcProgress;
});
